export enum APP_ENV_TYPE {
  LOCAL = "local",
  SIT = "sit",
  PRODUCTION = "production",
}

/**
 * 获取当前的环境
 * @returns {APP_ENV}
 */
export const getEnv = (): APP_ENV_TYPE => {
  const { REACT_APP_ENV } = process.env as unknown as { REACT_APP_ENV: APP_ENV_TYPE };
  if (REACT_APP_ENV && Object.values(APP_ENV_TYPE).includes(REACT_APP_ENV)) {
    return REACT_APP_ENV;
  }
  const { hostname } = window.location;
  if (hostname.endsWith(".stac.fun")) {
    return APP_ENV_TYPE.SIT;
  }
  if (hostname.endsWith("localhost")) {
    return APP_ENV_TYPE.LOCAL;
  }
  return APP_ENV_TYPE.PRODUCTION;
};

export const isLocal = getEnv() === APP_ENV_TYPE.LOCAL;
export const isSit = getEnv() === APP_ENV_TYPE.SIT;
export const isProduction = getEnv() === APP_ENV_TYPE.PRODUCTION;

export const isAndroid = /android/i.test(navigator.userAgent);
